<template>
  <div>
    <ul v-if="listType === 'unordered'" class="list-none text-gray-900 bg-white border border-gray-200 rounded-lg">
      <slot />
    </ul>
    <ol v-else class="list-none text-gray-900 bg-white border border-gray-200 rounded-lg">
      <slot />
    </ol>
  </div>
</template>
<script>
export default {
  props: {
    listType: {
      type: String,
      default: "unordered",
    },
  },
};
</script>
